import { MessageService } from 'primeng/api';
import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { PartnerService } from '../../../../services/partner.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Router, ActivatedRoute } from '@angular/router';
import { SharedServiceComponent } from '../../../shared/shared-service/shared-service.component';

@Component({
  selector: 'app-service-types',
  templateUrl: './service-types.component.html',
  styleUrls: ['./service-types.component.scss'],
})
export class ServiceTypesComponent implements OnInit {
  public loading: boolean = false;
  public serviceTypes: any = [];
  public currencySymbol = '';
  public allServiceTypes: any = [];
  public categories: any = [];
  public category: string;
  public open: string;
  public partner: any;
  public Categories = [];
  public isPortal = true;
  public addNew = false;
  public categoryView = false;
  public search = '';
  public technicians: any = [];
  public showFittings = false;

  constructor(
    public router: Router,
    public messageService: MessageService,
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    public modalService: NgbModal,
    public route: ActivatedRoute,
  ) {
    this.partner = this.helpersService.getPartnerData();
    this.currencySymbol = helpersService.getPartnerData().CurrencySymbol;
  }

  @ViewChild(SharedServiceComponent) child: SharedServiceComponent;

  ngOnInit() {
    if (this.route.snapshot.routeConfig.path === 'fittings') {
      this.showFittings = true;
    }
    //this.getServiceTypes();
    this.getTechnicians();
  }

  getTechnicians() {
    this.partnerService
      .getPartnerTechnicians(this.helpersService.getPartnerId())
      .subscribe((technicians) => {
        this.technicians = technicians.filter((x) => x.IsActive);
      });
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    this.addNew = false;
  }

  setCategories = (categories) => {
    this.Categories = categories;
  };

  toggleAdd() {
    setTimeout(() => {
      this.addNew = !this.addNew;
    }, 10);
  }

  addCategory() {
    this.Categories.unshift({ name: '', editing: true });
  }

  setOpen(category) {
    this.open = this.open === category ? '' : category;
  }

  editServiceType(serviceType) {
    // const modalRef = this.modalService.open(AddEditServiceTypesComponent, {
    //   size: "lg",
    //   backdrop: "static",
    //   windowClass: "service-type-modal"
    // });
    // modalRef.componentInstance.partnerId = this.partnerID;
    // modalRef.componentInstance.serviceType = serviceType;
    // modalRef.result.then(
    //   result => {
    //     this.getServiceTypes();
    //   },
    //   onrejected => {
    //     this.getServiceTypes();
    //   }
    // );

    this.helpersService.setService(serviceType);
  }

  addServiceType() {
    this.child.addServiceType('');
  }

  toggleView() {
    this.categoryView = !this.categoryView;
  }

  setSearch(search) {
    this.search = search;
  }
}
